/**
 * Created by lg on 18/8/22.
 */
const ConfigHelper = {};
/* 系统配置 */
export function init(target) {
  // 登录url ,请求url
  let login_url = 'http://uc.jdcloud.com/login';
  let server_url = '/ccs-api';
  let return_url = 'http://ccs-console.jdcloud.com';
  let completion_url = 'http://uc.jcloud.com/passport/completion';
  const cabinet_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-cabinet-list';
  const alarm_rules_url = 'https://docs.jdcloud.com/cloud-cabinet-service/View-Alarm-Rules';
  const account_manage_url = 'https://uc.jdcloud.com/account/contacts';
  const equipment_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-device-list';
  const region_inspection_url = 'https://docs.jdcloud.com/cn/cloud-cabinet-service/DataCenter-Inspection';
  const device_inspection_url = 'https://docs.jdcloud.com/cn/cloud-cabinet-service/DataCenter-Inspection';

  const ip_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-ipaddress-list';
  const bandwidth_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-bandwidth-list';
  const worksheet_server_url =
    "https://docs.jdcloud.com/cloud-cabinet-service/submitticket";
  const myworksheet_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-tickets-list';
  const bandwidthtraffic_server_url = 'https://docs.jdcloud.com/cloud-cabinet-service/view-bandwidth-traffic-list';
  const alarm_history = 'https://docs.jdcloud.com/cloud-cabinet-service/View-Alarm-History';
  const realname_url = 'https://realname.jdcloud.com/account/verify'; // 实名认证地址
  const order_url = 'http://buy.jdcloud.com'; // 订单地址
  switch (process.env.BUILD_ENV) {
    case 'local':
      /* 本地环境---使用代理 config下proxyConfig.js */
      server_url = '/apis';
      return_url = 'ccs-console.jdcloud.com';
      break;
    case 'dev':
      /* 开发环境 172.18.168.156 */
      break;
    case 'test':
      /* 测试环境 192.168.167.50 */
      break;
    case 'pre':
      /* 预发环境 192.168.162.38 */

      break;
    case 'prod':
      /* 线上环境 */
      return_url = 'https://ccs-console.jdcloud.com';
      login_url = 'https://uc.jdcloud.com/login';
      completion_url = 'https://uc.jcloud.com/passport/completion';
      break;
  }
  if (!login_url || !server_url) {
    console.log(`  Build ConfigHelper config url have null, build env :${process.env.BUILD_ENV}`);
  }

  return {
    // 根vue
    ROOT_VUE: target,
    // 请求url
    SERVER_URL: server_url,
    // 重定向url
    RETURN_URL: return_url,
    // 登录页url
    LOGIN_URL: login_url,
    // 未激活跳转url
    COMPLETION_URL: completion_url,
    CABINET_SERVER_URL: cabinet_server_url,
    ALARM_RULES_URL: alarm_rules_url,
    ACCOUNT_MANAGE_URL: account_manage_url,
    EUQIPMENT_SERVER_URL: equipment_server_url,
    REGION_iNSPECTION_URL: region_inspection_url,
    DEVICE_iNSPECTION_URL: device_inspection_url,
    IP_SERVER_URL: ip_server_url,
    BANDWIDTH_SERVER_URL: bandwidth_server_url,
    WORKSHEET_SERVER_URL: worksheet_server_url,
    MYWORKSHEET_SERVER_URL: myworksheet_server_url,
    BANDWIDTHTRAFFIC_SERVER_URL: bandwidthtraffic_server_url,
    ALARM_HISTORY: alarm_history,
    REALNAME_URL: realname_url,
    ORDER_URL: order_url,
  };
}

export default ConfigHelper;



// WEBPACK FOOTER //
// ./src/common/ConfigHelper.js